import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HelperService {
  private downloadInfo: BehaviorSubject<boolean>;
  private downloadPercentage : BehaviorSubject<number>;
  private downloadFileSize: BehaviorSubject<string>;
  private downloadFileState: BehaviorSubject<string>;
  private downloadFileName: BehaviorSubject<string>;
  
  constructor() {
    this.downloadInfo = new BehaviorSubject<boolean>(false);
    this.downloadPercentage = new BehaviorSubject<number>(0);
    this.downloadFileSize = new BehaviorSubject<string>('');
    this.downloadFileState = new BehaviorSubject<string>('');
    this.downloadFileName = new BehaviorSubject<string>('');
  }

  customeDownload(): Observable<boolean> {
    return this.downloadInfo.asObservable();
  }

  customePercentage(): Observable<number> {
    return this.downloadPercentage.asObservable();
  }

  customeFileSize(): Observable<string> {
    return this.downloadFileSize.asObservable();
  }

  customeFileState(): Observable<string> {
    return this.downloadFileState.asObservable();
  }

  customeFileName(): Observable<string> {
    return this.downloadFileName.asObservable();
  }

  setDownload(loader: boolean): void {
      this.downloadInfo.next(loader);
  }

  setPercentage(loader: number): void {
    this.downloadPercentage.next(loader);
  }

  setState(loader: string): void {
    this.downloadFileState.next(loader);
  }

  setFileSize(loader: string): void {
    this.downloadFileSize.next(loader);
  }

  setFileName(loader: string): void {
    this.downloadFileName.next(loader);
  }


  formatBytes(bytes:any, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
}
